import React, { useContext, useState, useEffect } from "react"
import { GeoIPContext } from "../../context/GeoIPContext"
import "./CountryPopup.css"

const CountryPopup = () => {
    const { country, loading } = useContext(GeoIPContext)
    const [isOpen, setIsOpen] = useState(true)
    const [shouldShow, setShouldShow] = useState(false)

    const now = Date.now()
    const THREE_DAYS = 259200000 // 3 days in ms
    const STORAGE_KEY = "country_popup_last_seen"

    // cooldown + auto-hide
    useEffect(() => {
        if (loading) return // wait for country to load

        const lastSeenRaw = localStorage.getItem(STORAGE_KEY)
        const lastSeen = lastSeenRaw ? parseInt(lastSeenRaw, 10) : null

        if (lastSeen && now - lastSeen < THREE_DAYS) {
            setShouldShow(false)
            return
        }

        // Only show popup for US users
        if (country === "US") {
            setShouldShow(true)
            localStorage.setItem(STORAGE_KEY, now.toString())
            const timer = setTimeout(() => setIsOpen(false), 10000)
            return () => clearTimeout(timer)
        }
    }, [loading, country])

    // Don’t render while loading or if closed or if within cooldown
    if (loading || !isOpen || !shouldShow) return null

    let content = null
    switch (country) {
        case "US":
            content = (
                <div>
                    <p>At the moment, we do not ship to the United States.</p>
                    <p>Subscribe to our newsletter to stay updated on future availability.</p>
                    <p>Thank you for your understanding,</p>
                    <p>
                        <br />
                        <strong>The PERCKO Team</strong>
                    </p>
                </div>
            )
            break
        default:
            return null
    }

    return (
        <>
            <div
                className="country-popup-overlay"
                onClick={() => setIsOpen(false)}
                aria-hidden="true"
            />
            <div
                className="country-popup"
                role="dialog"
                aria-modal="true"
                aria-label="Country notice"
            >
                <button
                    className="country-popup-close"
                    onClick={() => setIsOpen(false)}
                    aria-label="Close"
                >
                    ×
                </button>
                {content}
            </div>
        </>
    )
}

export default CountryPopup